import { AddCircleOutline, Close, Visibility } from "@mui/icons-material";
import {
  Button,
  Card,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import { Form } from "formik";

export const StyledAccident = {
  TableActions: styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(0.5),
    width: "100%",
    whiteSpace: "nowrap",
  })),
};
export const StyledDetailsTable = {
  Container: styled("div")(({ theme }) => ({
    flex: 1,
    flexDirection: "column",
    display: "flex",
    padding: theme.spacing(2),
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(2),
  })),
  Details: styled("div")(({ theme }) => ({
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderBottom: `solid 1px ${theme.palette.divider}`,
  })),
  TextTitle: styled("div")({
    fontWeight: "bold",
  }),
  TextValue: styled("div")({
    fontWeight: 300,
  }),
};
export const StyledAddDocumentationCards = {
  Container: styled("div")({
    display: "flex",
    flexDirection: "column",
    height: 265,
    overflow: "auto",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 2,
    paddingBottom: 5,
  }),

  Card: styled(Paper)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
    padding: 5,
    paddingLeft: 10,
    borderRadius: 5,
  }),

  Button: styled("button")({
    background: "transparent",
    border: "none",
    padding: 0,
    marginTop: 2,
  }),

  Icon: styled(AddCircleOutline)({
    cursor: "pointer",
  }),

  NoDataMessage: styled(Typography)({
    textAlign: "center",
    marginTop: 20,
  }),

  ButtonsContainer: styled('div')({
    paddingLeft: 5,
    justifyContent: "space-between",
  })
};

export const StyledAccidentDashboard = {
  RowContainer: styled("div")({
    display: "flex",
    alignItems: "center",
  }),

  HeaderDiv: styled(Paper)(({ theme }) => ({
    flex: 1,
    margin: 10,
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
  })),

  AddDocumentationDiv: styled(Paper)({
    flex: 1,
    height: 300,
    minWidth: 300,
    margin: 10,
    borderRadius: 5,
    backgroundColor: "#f5f5f5",
  }),

  AccidentDocumentsDiv: styled(Paper)({
    flex: 1.5,
    height: 300,
    minWidth: 500,
    margin: 10,
    borderRadius: 5,
    backgroundColor: "#f5f5f5",
  }),

  FormAndAppointmentsContainer: styled("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    margin: 10,
    minWidth: 300,
    minHeight: 300,
  }),

  FormsDiv: styled(Paper)({
    flex: 1,
    marginBottom: 20,
    borderRadius: 5,
    backgroundColor: "#f5f5f5",
    minHeight: 150,
  }),

  AppointmentsInProviderDiv: styled(Paper)({
    flex: 1,
    borderRadius: 5,
    marginTop: 20,
    backgroundColor: "#f5f5f5",
    minHeight: 150,
  }),

  CalendarDiv: styled("div")({
    flex: 1.5,
    minWidth: 500,
    height: 300,
    margin: "10px 10px 60px 10px",
  }),

  MessagingDiv: styled(Paper)({
    flex: 1,
    margin: "10px 10px 60px 10px",
    borderRadius: 5,
    backgroundColor: "#ffffff",
    minHeight: 150,
    minWidth: 0,
    width: "100%",
    overflow: "hidden",
  }),
};

export const StyledCardTitle = {
  Container: styled("div", { shouldForwardProp: (prop) => prop !== "color" })(
    ({ theme, color }) => ({
      position: "relative",
      display: "flex",
      justifyContent: "center",
      backgroundColor:
        color === "secondary"
          ? theme.palette.secondary.light
          : theme.palette.primary.main,
      borderRadius: "5px 5px 0px 0px",
      padding: 5,
    }),
  ),
  Button: styled("div")({
    position: "absolute",
    right: 10,
    top: 3,
    color: "white",
    background: "transparent",
    border: "none",
    display: "flex",
    alignItems: "center",
  }),
};

export const StyledAccidentDocumentsCards = {
  Container: styled("div")({
    display: "flex",
    flexDirection: "column",
    height: 265,
    overflow: "auto",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 2,
    paddingBottom: 5,
  }),

  Card: styled(Paper)(({ theme, backgroundColor }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 5,
    backgroundcolor: backgroundColor || "transparent",
  })),

  RowContainer: styled("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  }),

  ActionsContainer: styled("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),

  Button: styled("div")({
    cursor: "pointer",
    marginLeft: 15,
  }),

  DisableButton: styled("div")({
    color: "lightgrey",
    marginLeft: 15,
  }),

  EmptyState: styled(Typography)({
    alignSelf: "center",
    marginTop: 30,
  }),

  ButtonAsociarFormulario: styled("button")({
    background: "transparent",
    border: "none",
    cursor: "pointer",
    marginLeft: 15,
  }),

  FormInfoContainer: styled("div")({
    width: 250,
  }),

  FormDate: styled(Typography)({
    color: "grey",
  }),

  SentMethodIcon: styled("div")({
    color: "grey",
  }),

  RecivedByArt: styled(Typography)({
    marginLeft: 5,
    color: "grey",
  }),
};

export const StyledSignForm = {
  RowContainer: styled("div")({
    display: "flex",
    flex: 1,
    alignItems: "center",
    marginBottom: 10,
  }),

  LoadingContainer: styled(DialogContent)({
    marginTop: 40,
    marginBottom: 80,
  }),
};

export const StyledAccidenteader = {
  Container: styled("div")({
    display: "flex",
    justifyContent: "space-between",
    padding: 8,
  }),

  Name: styled(Typography)({
    fontWeight: "bold",
  }),

  Alta: styled(Typography)({
    color: "#cf0000",
    fontWeight: "bold",
  }),
};

export const StyledAccidentPrePrintedFormsCards = {
  Container: styled("div")({
    display: "flex",
    flexDirection: "column",
    height: 100,
    overflow: "auto",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 2,
    paddingBottom: 5,
  }),

  Card: styled(Paper)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
    padding: 5,
    paddingLeft: 10,
    borderRadius: 5,
  }),

  Button: styled("div")({
    cursor: "pointer",
  }),

  EmptyState: styled(Typography)({
    alignSelf: "center",
    marginTop: 20,
  }),
};

export const StyledEditAccidentForm = {
  Container: styled("div")({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1, // Permitir que el contenedor se expanda
    padding: 20,
    boxSizing: "border-box",
  }),

  input: {
    marginBottom: "15px",
    width: "100%",
  },
};

export const StyledEditAccidentFormContainer = {
  Container: styled(DialogContent)({
    display: "flex",
    flexDirection: "column", // Asegura que los elementos se apilen verticalmente
    flexGrow: 1, // Permite que el contenedor crezca dinámicamente
    padding: "10px", // Añade un margen interno estándar
    justifyContent: "flex-start", // Coloca los elementos al inicio
    alignItems: "stretch", // Asegura que los hijos ocupen todo el ancho disponible
  }),

  CircularLoadingContainer: styled("div")({
    flex: 1,
    marginTop: 80,
    marginBottom: 100,
  }),
};

export const StyledCloseAccident = {
  Container: styled("div")({
    display: "flex",
    flexDirection: "column",
    padding: "10px 20px",
  }),

  Title: styled(DialogTitle)({
    padding: "16px 16px 0px",
  }),

  ContentContainer: styled(Card)({
    minWidth: "500px",
    minHeight: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),

  FormContainer: styled(Form)({
    display: "flex",
    flexDirection: "column",
    width: "500px",
  }),

  FormControl: styled("div")({
    margin: "10px 0",
  }),

  ButtonContainer: styled("div")({
    padding: "30px 0px 0px 10px",
    display: "flex",
    justifyContent: "end",
  }),

  StyledButton: styled(Button)(({ theme }) => ({
    margin: "0px 10px",
  })),

  CloseAccidentButton: styled(Button)({
    margin: "0px 10px",
    backgroundColor: "red",
    color: "white",
  }),
};
export const StyledNewAccident = {
  Title: styled(Typography)(({ theme }) => ({
    marginBottom: 20,
  })),

  StyledPaper: styled(Paper)(({ theme }) => ({
    display: "flex",
    flexDirection: "row", // Cambiado a 'row' para colocar los inputs en línea
    padding: 20,
    width: "100%",
  })),

  Loading: styled("div")(({ theme }) => ({
    marginTop: 100,
  })),
};

export const StyledAccidentsFecadeAndOpen = {
  TitleContainer: styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 40,
    padding: 8,
    paddingLeft: 30,
    paddingRight: 60,
    backgroundColor: theme.palette.primary.main,
  })),

  Title: styled(Typography)(({ theme }) => ({
    color: "white",
  })),

  CloseIcon: styled(Close)(({ theme }) => ({
    position: "absolute",
    right: 10,
    color: "white",
    cursor: "pointer",
    width: 25,
    height: 25,
    marginTop: 25,
    marginBottom: 25,
  })),

  CardContainer: styled(DialogContent)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: 700,
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: "#f5f5f5",
  })),

  EmptyState: styled("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: 250,
  }),

  CircularLoadingContainer: styled("div")({
    flex: 1,
    marginTop: 80,
    marginBottom: 100,
  }),

  ArtText: styled(Typography)(({ theme }) => ({
    marginTop: 20,
    marginBottom: 80,
  })),
};

export const StyledFecadeAccidentCard = {
  Card: styled(Paper)(({ theme }) => ({
    display: "flex",
    margin: 10,
    padding: 15,
  })),

  CardLeftContainer: styled("div")({
    flex: 3,
    display: "flex",
    flexDirection: "column",
  }),

  CardRightContainer: styled("div")({
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),

  CardIcon: styled("div")({
    width: 30,
    height: 30,
    cursor: "pointer",
  }),
};

export const StyledOpenAccidentCards = {
  Card: styled(Paper)(({ theme }) => ({
    display: "flex",
    margin: 10,
    padding: 15,
  })),

  CardLeftContainer: styled("div")({
    flex: 3,
    display: "flex",
    flexDirection: "column",
  }),

  CardRightContainer: styled("div")({
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),

  CardIcon: styled(Visibility)(({ theme }) => ({
    width: 30,
    height: 30,
    cursor: "pointer",
  })),
};

export const StyledSearchContainer = {
  Container: styled("div")({
    marginBottom: "24px",
  }),

  Title: styled("div")({
    fontFamily: "Roboto, sans-serif",
    fontSize: "large",
    fontWeight: 500,
    color: "#484848",
    marginBottom: "8px",
  }),
};

export const StyledActivateAccountContainer = {
  Text: styled(Typography)({
    color: "#303030",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "bold",
    fontSize: "medium",
  }),

  GridContainer: styled(Grid)({
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: "linear-gradient(120deg, #96d43a, #539aff)",
  }),

  LogoImage: styled("img")({
    paddingBottom: "60px",
  }),

  LoginCard: styled(Card)({
    minWidth: "450px",
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px grey",
    borderRadius: "10px",
    padding: "30px 25px 10px 25px",
  }),

  LoginContainer: styled(Grid)({
    marginBottom: 50,
    marginTop: 50,
  }),
};

export const StyledArtSearchContainer = {
  Container: styled("div")({
    marginBottom: "24px",
  }),

  Title: styled("div")({
    fontFamily: "Roboto, sans-serif",
    fontSize: "large",
    fontWeight: 500,
    color: "#484848",
    marginBottom: "8px",
  }),
};

export const StyledAccidentArtTable = {
  DetailsTableContainer: styled("div")({
    backgroundColor: "#fafafa",
  }),
  errorChip: {
    borderColor: "#f37c578f",
    color: "white",
    backgroundColor: "#FF9A78",
    fontFamily: "Roboto, sans-serif",
  },
  successChip: {
    borderColor: "green",
    backgroundColor: "#00800094",
    color: "white",
    fontFamily: "Roboto, sans-serif",
  },
};
